import { MapPin } from "lucide-react";
import { Reveal, SectionTag } from "@/components/Reveal";

const REGIONS = [
  { state: "Madhya Pradesh", cities: ["Balaghat", "Jabalpur", "Bhopal", "Indore", "Other Healthcare Markets"] },
  { state: "Chhattisgarh", cities: ["Raipur", "Bhilai", "Durg", "Bilaspur", "Other Healthcare Markets"] },
  { state: "Maharashtra", cities: ["Nagpur", "Amravati", "Akola", "Pune", "Mumbai", "Other Healthcare Markets"] },
];

export const Regional = () => (
  <section id="regional" className="relative overflow-hidden bg-[#EAF3F8] py-24 sm:py-32">
    <div className="pointer-events-none absolute -top-32 right-0 h-[380px] w-[380px] rounded-full bg-[#5FA832]/5 blur-[110px]" />
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionTag index="10" label="Our Regional Focus" />
        <h2 className="font-display mt-6 max-w-3xl text-2xl font-bold tracking-tight text-[#0B3C5C] sm:text-3xl lg:text-4xl">
          Connecting Healthcare Across Central & Western India
        </h2>
        <p className="mt-5 max-w-2xl text-base text-[#4A6B82] sm:text-lg">
          Our growth vision focuses on building healthcare relationships and opportunities across:
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-3">
        {REGIONS.map((r, i) => (
          <Reveal key={r.state} delay={i * 0.09}>
            <div
              data-testid={`region-card-${i + 1}`}
              className="group h-full rounded-2xl border border-[#0B3C5C]/10 bg-white/70 p-8 transition-all duration-300 hover:-translate-y-1 hover:border-teal-500/30"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#5FA832]/10">
                  <MapPin className="h-5 w-5 text-[#4C8F2F]" />
                </span>
                <h3 className="font-mono-x text-sm font-bold uppercase tracking-[0.2em] text-[#0B3C5C]">
                  {r.state}
                </h3>
              </div>
              <ul className="mt-6 space-y-2.5">
                {r.cities.map((c) => (
                  <li key={c} className="flex items-center gap-3 text-sm text-[#33586F]">
                    <span className="h-1 w-1 rotate-45 bg-amber-500" />
                    {c}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.2}>
        <div className="mt-12 flex flex-col items-start gap-5 rounded-2xl border border-[#0B3C5C]/10 bg-[#0B3C5C]/[0.03] p-8 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <p className="font-display text-lg font-bold text-[#0B3C5C]">Have a healthcare requirement in your city?</p>
            <p className="mt-1 text-sm text-[#4A6B82]">Let's connect.</p>
          </div>
          <a
            href="#enquiry"
            data-testid="regional-cta-contact"
            className="rounded-full bg-[#5FA832] px-8 py-4 text-sm font-bold text-white transition-all duration-300 hover:bg-[#4C8F2F] hover:shadow-xl hover:shadow-[#5FA832]/25"
          >
            Contact Healthcare Solutions
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
